import { z } from "zod";

export const COLOR_THEMES = ["meadow", "ocean", "berry", "amber"] as const;
export type ColorTheme = (typeof COLOR_THEMES)[number];

export const DEFAULT_COLOR_THEME: ColorTheme = "meadow";

export const colorThemeFormSchema = z.object({
  colorTheme: z.enum(COLOR_THEMES),
});
